import { CommonModule } from '@angular/common';
import { Component, Inject, InjectionToken } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule
  ],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss'
})

export class AlertDialogComponent {
  title: string;
  message: string;
  yesButtonText: string;
  noButtonText: string;
  showNoButton: boolean;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogModel
  ) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.yesButtonText = data.yesButtonText;
    this.noButtonText = data.noButtonText;
    this.showNoButton = data.showNoButton;
  }

  ngOnInit() {}

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

export class AlertDialogModel {
  constructor(
    public title: string,
    public message: string,
    public yesButtonText: string,
    public noButtonText: string,
    public showNoButton: boolean
  ) {}
}